'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M3.05563 1.35874C2.5871 0.890195 1.82745 0.890185 1.35891 1.35872C0.890363 1.82725 0.890353 2.5869 1.35888 3.05544L10.3008 11.9976L1.3593 20.9393C0.89077 21.4078 0.890779 22.1675 1.35932 22.636C1.82787 23.1045 2.58752 23.1045 3.05605 22.636L11.9975 13.6943L20.9389 22.636C21.4075 23.1045 22.1671 23.1045 22.6357 22.636C23.1042 22.1675 23.1042 21.4078 22.6357 20.9393L13.6942 11.9976L22.6361 3.05544C23.1046 2.5869 23.1046 1.82725 22.6361 1.35872C22.1675 0.890185 21.4079 0.890195 20.9394 1.35874L11.9975 10.3008L3.05563 1.35874Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
